export default __webpack_public_path__ + "static/media/photo7.a5248a1f.jpg";